import { useEffect, useState } from 'react';
import { publicApi } from '../api/client';

export function usePublicList(entity) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    setLoading(true);
    publicApi.list(entity)
      .then((d) => { if (alive) setData(d); })
      .catch((e) => { if (alive) setErr(e?.message || 'Xəta'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [entity]);

  return { data, loading, err };
}
